var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{staticClass:"add-btn",class:_vm.otherClass,attrs:{"fab":"","color":_vm.color},on:{"click":_vm.onClick}},[_c('v-icon',[_vm._v("ri-add-line")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }